export { default } from './ResultSingleItem';
